export const referral: Record<string, string> = {
  // Header
  'Earn rewards for every referral': 'Zaradi nagrade za svaku preporuku',

  // Founding Member badge
  'You are Founding Member': 'Ti si Founding Member',
  'A permanent badge for the first 100 traders who actually posted here — you made the cut.':
    'Trajan bedž za prvih 100 trejdera koji su ovde stvarno nešto objavili — ti si uspeo.',
  'Founding Member badge': 'Founding Member bedž',
  'spots left': 'mesta preostalo',
  'Post your first trade idea or forum comment to claim a permanent Founding Member badge — only the first 100 get one.':
    'Objavi prvu trade ideju ili komentar na forumu da osvojiš trajan Founding Member bedž — dobija ga samo prvih 100.',

  // Referral code card
  'YOUR REFERRAL CODE': 'TVOJ KOD ZA PREPORUKU',
  'Share this code or your referral link to earn rewards': 'Podeli ovaj kod ili svoj link za preporuku da zaradiš nagrade',
  'Copy Link': 'Kopiraj link',
  'SHORT': 'KRATAK',

  // Stats grid
  'Total Referred': 'Ukupno preporučenih',
  'Free Signups': 'Besplatne registracije',
  'Subscribers': 'Pretplatnici',
  'XP Earned': 'Zarađeni XP',
  'Pending Rewards': 'Nagrade na čekanju',
  'Approved Rewards': 'Odobrene nagrade',
  'Lifetime Earnings': 'Ukupna zarada',
  'Creators': 'Kreatori',

  // Milestones
  'Recruiter Milestones': 'Prekretnice regrutera',
  'qualified': 'kvalifikovanih',
  'Qualified referrals to unlock': 'Kvalifikovanih preporuka do otključavanja',
  "All milestones unlocked — you're a Legend Recruiter!": 'Sve prekretnice otključane — ti si Legenda regrutovanja!',

  // How it works
  'How It Works': 'Kako funkcioniše',
  'Share your link': 'Podeli svoj link',
  'Share your short /r link with traders and friends': 'Podeli svoj kratki /r link sa trejderima i prijateljima',
  'They sign up & post': 'Oni se registruju i objave',
  'When they join and post their first idea, you earn +150 XP and badge progress': 'Kada se pridruže i objave prvu ideju, zarađuješ +150 XP i napredak ka bedžu',
  'They subscribe': 'Oni se pretplate',
  'Earn': 'Zaradi',
  'of every payment they make to a paid channel, for up to': 'od svake uplate koju naprave plaćenom kanalu, tokom najviše',
  'months': 'meseci',
  'Track & get paid': 'Prati i naplati',
  'Cash rewards clear after a 30-day holdback, then are paid out': 'Novčane nagrade se oslobađaju posle 30 dana zadržavanja, zatim se isplaćuju',

  // Reward structure
  'Reward Structure': 'Struktura nagrada',
  'Subscriber': 'Pretplatnik',
  'Of every payment, up to': 'Od svake uplate, tokom najviše',
  'Creator': 'Kreator',
  'Of their first month launched': 'Od njihovog prvog pokrenutog meseca',
  'Free Signup': 'Besplatna registracija',
  'When they post their first idea': 'Kada objave svoju prvu ideju',
  'Cash rewards have a 30-day holdback (refund window) before approval, then are paid out. Rewards are canceled if the subscription fails or is refunded.': 'Novčane nagrade imaju 30 dana zadržavanja (period za povraćaj) pre odobrenja, a zatim se isplaćuju. Nagrade se otkazuju ako pretplata ne uspe ili bude refundirana.',

  // Tabs + tables
  'Attributions': 'Atribucije',
  'Rewards': 'Nagrade',
  'Type': 'Tip',
  'Status': 'Status',
  'Channel': 'Kanal',
  'Date': 'Datum',
  'Amount': 'Iznos',
  'View': 'Prikaži',
  'No referrals yet': 'Još nema preporuka',
  'Share your link to start earning': 'Podeli svoj link da počneš da zarađuješ',
  'No rewards yet': 'Još nema nagrada',
  'Rewards appear here when referrals convert': 'Nagrade se pojavljuju ovde kada se preporuke konvertuju',
  'mo': 'mes.',
  'Clears': 'Oslobađa se',

  // Status labels
  'Pending': 'Na čekanju',
  'Approved': 'Odobreno',
  // 'Paid' already lives in channels.ts
  'Canceled': 'Otkazano',
  'Converted': 'Konvertovano',
  'Qualified': 'Kvalifikovano',

  // Attribution / reward type values (displayed lowercase)
  'creator': 'kreator',
  'subscriber': 'pretplatnik',
  'subscriber referral': 'preporuka pretplatnika',
  'creator referral': 'preporuka kreatora',
  'free signup xp': 'XP za besplatnu registraciju',
};
